<div class="date-picker">
  <input type="hidden" id="from-date" name="fromDate" *ngIf="date" [(ngModel)]="fromDate" />
  <input type="hidden" id="to-date" name="toDate" *ngIf="isDateRange" [(ngModel)]="toDate" />
  <span id="date-picker" data-hj-ignore-attributes #date tabindex="0" (click)="toggleDatePicker(null, $event)" (keyup)="toggleDatePicker('open')" (keydown)="onEnter($event)" class="date-picker__text arrow-down input" [innerHTML]="dateText"></span>
  <div class="dropdown__modal" [hidden]="!isOpen">
    <div class="date-picker__calendar"></div>
    <button type="button" class="date-picker__apply btn u-no-button-style" tabindex="0" (click)="closeDP();" [disabled]="!date || !endDate">{{ applyLabel }}</button>
  </div>
</div>